import { GalleryList } from './gallery'

class BriefGalleryList extends GalleryList {
    getEntityKey() {
        return "photographer/brief_gallery"
    }
}

export const briefGalleryList = new BriefGalleryList("brief_gallery_default")
export const briefGalleryListForPhotoArt = new BriefGalleryList("brief_gallery_list_for_photo_art_default")